import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Container } from 'components/recent-items-carousel/styled';
import { MARGIN_TOP } from 'pages/home/constants';
import { primitive } from 'styles/constants/primitives';

export const RecentItemsContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 0.75rem;
  ${MARGIN_TOP};
  ${Styles.desktop`
    max-width: 1050px;
    padding: 0;
  `}
  ${Container} {
    padding: 0;
  }
`;

export const HeaderLink = styled(Link)`
  align-items: center;
  color: ${Styles.color.primary};
  display: flex;
  font-size: 1rem;
  margin-left: 12px;
  text-decoration: none;
  text-transform: capitalize;
  ${Styles.desktop`
    height: 100%;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  `}
`;

export const HeaderTextWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  ${Styles.mobile`
    justify-content: space-between;
    margin: 0 1rem;
  `}
`;

export const IconWrapper = styled.span`
  margin-left: 8px;
`;

export const EmptyBoxWrapper = styled.div`
  display: flex;
  margin: ${primitive.$spacing4} ${primitive.$spacing4};
  padding: ${primitive.$spacing2} ${primitive.$spacing3};
  border: 1px solid ${Styles.color.secondary};
  border-radius: 8px;
`;

export const EmptyTextWrapper = styled.span`
  color: ${Styles.color.secondary};
  font-size: 14px;
  line-height: 20px;
  display: block;
`;

export const EmptyBoxIconWrapper = styled.span`
  margin-right: 8px;
  margin-top: 2px;
`;
